export default function AmenitiesList() {
    const amenities = [
        {
            name: "Chef's Kitchen",
            svg: (
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M4 12h16M4 18h16M4 6h16"/>
                </svg>
            )
        },
        {
            name: 'Game Room',
            svg: (
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M6 12h12M12 6v12"/>
                    <path d="M17.65 6.35a2 2 0 0 0-2.83 0L12 9.17l-2.83-2.82a2 2 0 0 0-2.83 2.83L9.17 12l-2.82 2.83a2 2 0 0 0 2.83 2.83L12 14.83l2.83 2.82a2 2 0 0 0 2.83-2.83L14.83 12l2.82-2.83a2 2 0 0 0 0-2.83z"/>
                </svg>
            )
        },
        {
            name: 'Wi-Fi',
            svg: (
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M5 12.55a8 8 0 0 1 14 0"/>
                    <path d="M2 8.82a15 15 0 0 1 20 0"/>
                    <path d="M8 16.29a4 4 0 0 1 8 0"/>
                    <line x1="12" y1="20" x2="12.01" y2="20"/>
                </svg>
            )
        },
        {
            name: 'TV',
            svg: (
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <rect x="2" y="7" width="20" height="15" rx="2" ry="2"/>
                    <polyline points="17 2 12 7 7 2"/>
                </svg>
            )
        },
        {
            name: 'Washer & Dryer',
            svg: (
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M21 12a9 9 0 1 1-9-9"/>
                    <path d="M3.55 16.84A6.4 6.4 0 0 1 3 12c0-3.04 2.08-5.58 4.94-6.32"/>
                    <path d="M20.45 7.16A6.4 6.4 0 0 0 21 12c0 3.04-2.08 5.58-4.94 6.32"/>
                </svg>
            )
        },
        {
            name: 'Free Parking',
            svg: (
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M12 2a10 10 0 1 0 10 10A10 10 0 0 0 12 2zm0 18a8 8 0 1 1 8-8 8 8 0 0 1-8 8z"/>
                    <path d="M12 14h-2v-4h4a2 2 0 0 1 0 4h-2z"/>
                </svg>
            )
        },
        {
            name: 'Indoor Fireplace',
            svg: (
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M2 12h20M12 2v20"/>
                    <path d="M18.36 5.64a9 9 0 1 0-12.72 0"/>
                </svg>
            )
        },
        {
            name: 'Outdoor Fire Pit',
            svg: (
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M21 16.5c0-3.87-3.13-7-7-7s-7 3.13-7 7"/>
                    <path d="M12 4v2"/>
                    <path d="M5.22 6.22l1.42 1.42"/>
                    <path d="M18.78 6.22l-1.42 1.42"/>
                </svg>
            )
        },
        {
            name: 'BBQ Grill',
            svg: (
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M20 13V5a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v8"/>
                    <path d="M4 13h16v5a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-5z"/>
                    <path d="M12 16v4"/>
                    <path d="M8 16v4"/>
                    <path d="M16 16v4"/>
                </svg>
            )
        },
        {
            name: 'Pet-Friendly',
            svg: (
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M12 2a10 10 0 0 0-3.16 19.5A10 10 0 0 0 12 22a10 10 0 0 0 3.16-2.5A10 10 0 0 0 12 2z"/>
                    <path d="M12 14a3 3 0 1 0 0-6 3 3 0 0 0 0 6z"/>
                </svg>
            )
        },
    ];

    const moreAmenities = [
        { name: 'Heating', category: 'Climate' },
        { name: 'Air Conditioning', category: 'Climate' },
        { name: 'Coffee Maker', category: 'Kitchen' },
        { name: 'Microwave', category: 'Kitchen' },
        { name: 'Dishwasher', category: 'Kitchen' },
        { name: 'Refrigerator', category: 'Kitchen' },
        { name: 'Cookware & Utensils', category: 'Kitchen' },
        { name: 'Dining Table for 12+', category: 'Kitchen' },
        { name: 'Linens & Towels', category: 'Bedroom & Bath' },
        { name: 'Hair Dryer', category: 'Bedroom & Bath' },
        { name: 'Iron & Board', category: 'Bedroom & Bath' },
        { name: 'Essentials (Soap, TP)', category: 'Bedroom & Bath' },
        { name: 'Deck/Patio', category: 'Outdoor' },
        { name: 'Mountain Views', category: 'Outdoor' },
        { name: 'Private Property', category: 'Outdoor' },
        { name: 'Fire Extinguisher', category: 'Safety' },
        { name: 'Smoke Detector', category: 'Safety' },
        { name: 'CO Detector', category: 'Safety' },
        { name: 'First Aid Kit', category: 'Safety' },
        { name: 'Books & Games', category: 'Entertainment' },
    ];

    return (
        <div className="w-full">
            <h2 className="font-bold text-2xl sm:text-3xl md:text-4xl mb-6">Amenities</h2>

            <h3 className="font-bold text-xl md:text-2xl mb-4 mt-6">Featured Amenities</h3>
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
                {amenities.map((amenity) => (
                    <div key={amenity.name} className="flex items-center gap-3 p-3 bg-green-950 bg-opacity-30 rounded-lg hover:bg-opacity-50 transition-all">
                        <div className="w-6 h-6 md:w-8 md:h-8 flex-shrink-0">{amenity.svg}</div>
                        <span className="text-sm md:text-base">{amenity.name}</span>
                    </div>
                ))}
            </div>

            <h3 className="font-bold text-xl md:text-2xl mb-4 mt-8">All Amenities</h3>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                {['Kitchen', 'Bedroom & Bath', 'Outdoor', 'Climate', 'Safety', 'Entertainment'].map((category) => (
                    <div key={category} className="bg-green-900 rounded-xl p-4 md:p-6">
                        <h4 className="font-bold text-lg md:text-xl mb-3 text-green-300">{category}</h4>
                        <ul className="space-y-2 text-sm md:text-base">
                            {moreAmenities
                                .filter((a) => a.category === category)
                                .map((amenity) => (
                                    <li key={amenity.name} className="flex items-center gap-2">
                                        <span className="text-green-400">•</span> {amenity.name}
                                    </li>
                                ))}
                        </ul>
                    </div>
                ))}
            </div>
        </div>
    );
}